import { Component, Input, OnInit, ViewChild, ElementRef, HostListener, Output, EventEmitter, ViewChildren, QueryList, SimpleChange, OnChanges } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { ParamsMedia, ErrorParamsMedia, FilterMedia, MediaQueovalModel, MediaExtranetModel, Options, MediaTypeCode } from '../../models';
import { ModalService } from '../../modal';
import { MediaService, CoreService } from '../../services';
import { ToastService } from '../../toast';
import { DialogService } from '../../dialog';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-list-media',
  templateUrl: './list_media.component.html',
  styleUrls: ['./list_media.component.css', '../media.component.css'],
})


export class ListMediaComponent implements OnInit, OnChanges {
  public medias: Array<ParamsMedia>;
  public PageManager
    : { ArrayPageTotal: Array<number>, indexSelectedPage: number, indexFirstMediaInclued: number, indexLastMediaExclued: number, numberStrartEndElements: [number, number], numberCenterElements: number }
    = { ArrayPageTotal: Array(0), indexSelectedPage: 0, indexFirstMediaInclued: 0, indexLastMediaExclued: 0, numberStrartEndElements: [10, 3], numberCenterElements: 3 };
  public ListTypes: Array<{ key: string; selected: boolean }>;
  public numberByPage: Array<number>;
  public sorted: Array<{ key: string; value: boolean }>;
  public TypeSortedSelected: string = '';
  public sortedAscending: boolean = true;
  public datePicker: { Mode: string; MainElementList: any[]; };
  public carouselIndex: number | null = null;
  public intervalCarousel: any = undefined;
  public PersonnalPreview: string = 'd-block';
  public loaded: boolean = false;
  public afficheMedia: ParamsMedia = new ParamsMedia;
  public imgCanNotAffiche: Array<string> = [];
  public selects: Array<boolean>;
  public ListMediaToDeleteFromDatabase: Array<ErrorParamsMedia> = new Array<ErrorParamsMedia>();

  public listIdMedia: Array<string> = [];
 // /**
 //* Player Plyr
 //*/
 // public playerPlyr: any;

  @ViewChild('nextCarousel', { static: false }) nextCarousel: ElementRef;
  @ViewChildren('DirectParentOfautoPreviews') DirectParentOfautoPreviews: QueryList<ElementRef>;

  // tslint:disable-next-line:no-input-rename
  @Input('filter') filter: FilterMedia;
  // tslint:disable-next-line:no-input-rename
  @Input('restrictedTo') restrictedTo: FilterMedia;
  // tslint:disable-next-line:no-input-rename
  @Input('medias') AllMedias: Array<ParamsMedia>;
  @Input('detectChangeNewMedia') detectChangeNewMedia: any;


  @Output() updateMedia: EventEmitter<ParamsMedia> = new EventEmitter<ParamsMedia>();
  @Output() selectMedia: EventEmitter<ParamsMedia> = new EventEmitter<ParamsMedia>();
  @HostListener('AllMedias') GetMedias(): void {
    this.loaded = false;
    this.InitProperties();
    this.fillInProperties();
    this.getMedias();
  }
  @HostListener('click', ['$event']) onClick(e: any): void {
    switch (e.target.id) {
      case 'selectButtonTop':
      case 'selectIdTop':
      case 'selectITop':
        this.selects[1] = false;
        break;

      case 'selectButtonBottom':
      case 'selectIdBottom':
      case 'selectIBottom':
        this.selects[0] = false;
        break;
      default:
        this.closeAlloptionsList();
    }
}


  constructor(
    private dialogService: DialogService,
    private toast: ToastService,
    private mediaService: MediaService,
    private modalService: ModalService,
    public coreService: CoreService
  ) {

  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }): void {
    let detectChangeNewMedia: boolean = false;
    let isFilter: boolean = false;
    let isRestricted: boolean = false;
    for (const propName in changes) {
      if (propName === 'detectChangeNewMedia') {
        detectChangeNewMedia = true;
      } else if (propName === 'filter') {
        isFilter = true;
      } else if (propName === 'restrictedTo') {
        isRestricted = true;
      }
    }
    if (isRestricted && isFilter) {
      this.InitProperties();
      this.fillInProperties();
    }
    if (detectChangeNewMedia) {
      this.loaded = false;
      this.getMedias();
    }

  }

  ngOnInit(): void {

    //this.InitProperties();
    //this.fillInProperties();
    // this.getMedias();

  }

  // #region METHODES PUBLIQUES
  public changePageContext(indexPage: number, GoToStart = false): void {
    if (indexPage < this.PageManager.ArrayPageTotal.length && indexPage > -1 || GoToStart) {
      this.PageManager.indexSelectedPage = indexPage;
      this.PageManager.indexFirstMediaInclued = this.filter.numberByPage * indexPage;
      this.PageManager.indexLastMediaExclued = this.filter.numberByPage * (indexPage + 1);
      this.ApplyFilters(this.AllMedias);
    }
  }

  public ApplyFilters(ListMedia: Array<ParamsMedia>): void {
    let ArrayMedias: Array<ParamsMedia> = new Array<ParamsMedia>();

    // filtre les médias par rapport aux filtres Utilisateur
    ListMedia.forEach((media: ParamsMedia) => {

      // compare le filtre par types (utilisateur) avec chaque média de la liste retournée par le serveur.
      // pour chaque filtre par types, on regarde si il est coché (par l'utilisateur), si c'est le cas, on compare le filtre et le type du média, si ils sont égaux on continue le contrôle des filtres
      let matchWithCheckedType: boolean = false;
      for (let i: number = 0; i < Object.entries(this.filter.byType).length; i++) {
        matchWithCheckedType = false;
        if (Object.entries(this.filter.byType)[i][1] === true) {
          const typeSelected: string = Object.entries(this.filter.byType)[i][0] === 'video' ? MediaTypeCode.VIDEO :
            Object.entries(this.filter.byType)[i][0] === 'image' ? MediaTypeCode.IMAGE :
              Object.entries(this.filter.byType)[i][0] === 'audio' ? MediaTypeCode.AUDIO :
                Object.entries(this.filter.byType)[i][0] === 'document' ? MediaTypeCode.DOCUMENT : '';
          if (media.Type === typeSelected) {
            matchWithCheckedType = true;
            break;
          }
        }

      }
      // compare le média aux filtres appliqués
      let mediaIsAddable: boolean =
        !matchWithCheckedType ? false :
          !media.Name.toLowerCase().includes(this.filter.byName.toLowerCase()) ? false : true;

      if (this.listIdMedia.length > 0) {
        mediaIsAddable = this.listIdMedia.includes(`${media.Ident}`) ? true : false
      }

      if (mediaIsAddable) {
        ArrayMedias.push(media);
      }

    });
    this.PageManager.ArrayPageTotal = Array(Math.ceil(ArrayMedias.length / this.filter.numberByPage));
    ArrayMedias = ArrayMedias.slice(this.PageManager.indexFirstMediaInclued, this.PageManager.indexLastMediaExclued);
    this.medias = JSON.parse(JSON.stringify(ArrayMedias));
  }

  // public deleteType(type: string, i: number) {
  //  this.filter.byType[type] = false;
  //  this.TypesSelected = this.TypesSelected.filter(word => word.toLowerCase() !== type.toLowerCase());
  //  this.TypesSelected = JSON.parse(JSON.stringify(this.TypesSelected))
  //  this.TypesNotSelected.push(type);
  //  this.TypesNotSelected = JSON.parse(JSON.stringify(this.TypesNotSelected));
  //  this.ApplyFilters(this.AllMedias);
  // }
  public addType(type: string): void {
    if (type === 'AllTypes') {
      this.filter.byType.audio = true;
      this.filter.byType.document = true;
      this.filter.byType.image = true;
      this.filter.byType.video = true;
    } else {
      this.filter.byType.audio = type === 'audio' ? true : false;
      this.filter.byType.document = type === 'document' ? true : false;
      this.filter.byType.image = type === 'image' ? true : false;
      this.filter.byType.video = type === 'video' ? true : false;
      for (let i: number = 0; i < 4; i++) {
        const _sorted: string = JSON.parse(JSON.stringify(this.sorted.filter((el: { key: string, value: boolean }) => el.key.toLowerCase() !== type.toLowerCase())));
        this.sorted = JSON.parse(JSON.stringify(_sorted));
      }
    }

    //for (let i: number = 0; i < Object.entries(this.filter.byType).length; i++) {
    //  const key: string = Object.keys(this.filter.byType)[i];
    //  // passe tous les filtres à true si type === 'AllTypes'
    //  if (type === 'AllTypes') {
    //    this.filter.byType[key] = true;
    //  } else {
    //    this.filter.byType[key] = key === type ? true : false;

    //    const _sorted: string = JSON.parse(JSON.stringify(this.sorted.filter((el: { key: string, value: boolean }) => el.key.toLowerCase() !== type.toLowerCase())));
    //    this.sorted = JSON.parse(JSON.stringify(_sorted));
    //  }
    //}
    for (let i: number = 0; i < this.ListTypes.length; i++) {
      // liste du select Html
      this.ListTypes[i].selected = this.ListTypes[i].key === type ? true : false;
    }
    this.changePageContext(0, true);
  }

  public onSort(type: Options | string): void {
    if (typeof(type) === 'string')
    {
      this.TypeSortedSelected =
        type === 'byType' ? 'Type' :
          type === 'byName' ? 'Name' :
            type === 'byDate' ? 'DateCreation' : '';
    } else
    {
      this.TypeSortedSelected =
        type.value === 'byType' ? 'Type' :
        type.value === 'byName' ? 'Name' :
          type.value === 'byDate' ? 'DateCreation' : '';
    }
    this.sorting();
    this.changePageContext(0);
  }

  public onOrdering(): void {
    this.filter.sorted.ascending = !this.filter.sorted.ascending;
    this.sorting();
    this.changePageContext(0);
  }

  public startCarousel(index: number, media: ParamsMedia): void {
    if (media.AutoPreviews.length > 1) {
      this.carouselIndex = index;
      this.resetClassListOfAutoPreviews(index);
      this.intervalCarousel = setInterval(() => {
        this.nextCarousel.nativeElement.click();
      }, 1000);
    } else if (media.AutoPreviews.length === 2) {
      this.carouselIndex = index;
    }
  }

  private resetClassListOfAutoPreviews(i: number): void {
    const ParentAutoPreview: ElementRef = this.DirectParentOfautoPreviews.toArray()[i];
    for (const autoPreview of ParentAutoPreview.nativeElement['children']) {
      autoPreview.classList.remove('active');
    }
    this.DirectParentOfautoPreviews.toArray()[i].nativeElement['children'][0].classList.add('active');
  }

  public stopCarousel(media: ParamsMedia, index: number): void {
    if (media.AutoPreviews.length > 1) {
      this.resetClassListOfAutoPreviews(index);
      clearInterval(this.intervalCarousel);
    } else if (media.AutoPreviews.length === 2) {
    }
    this.carouselIndex = null;
  }

  public getUpdateMedia(media: ParamsMedia): void {
    clearInterval(this.intervalCarousel);
    this.updateMedia.emit(media);
  }

  public deleteMedia(media: ParamsMedia): void {
    clearInterval(this.intervalCarousel);
    this.dialogService.showSplash(true);
    const previewsToDelete: string[] = media.PersonnalsPreviews.concat(media.AutoPreviews);

    const a: Observable<MediaQueovalModel> | Observable<MediaExtranetModel> = this.mediaService.deleteMedia(previewsToDelete, MediaTypeCode.PREVIEW);
    const b: Observable<MediaQueovalModel> | Observable<MediaExtranetModel> = this.mediaService.deleteMedia(media.FullName, media.Type);
    const c: Observable<MediaQueovalModel> = this.mediaService.DeleteMediaBo(media);
    forkJoin([a, b, c]).subscribe(
      (del: [MediaQueovalModel | MediaExtranetModel, MediaQueovalModel | MediaExtranetModel, MediaQueovalModel]): void => {

        if (del[0].Alert && del[0].Alert.length > 0) {
          del[0].Alert.split('<br />').forEach((alert: string) => {
            this.toast.showWarningToast(alert);
          });
        }
        if (del[1].Alert && del[1].Alert.length > 0) {
          del[1].Alert.split('<br />').forEach((alert: string) => {
            this.toast.showWarningToast(alert);
          });
        }
        if (del[2].Alert && del[2].Alert.length > 0) {
          del[2].Alert.split('<br />').forEach((alert: string) => {
            this.toast.showWarningToast(alert);
          });
        }

        let succes: boolean = true;
        if (del[0].HasError) {
          this.toast.showAlertToast(this.coreService.getTrad('FailureDeleteThumbnail'));
          succes = false;
        }
        if (del[1].HasError) {
          this.toast.showAlertToast(this.coreService.getTrad('FailureDeleteFile'));
          succes = false;
        }
        if (del[2].HasError) {
          this.toast.showAlertToast(this.coreService.getTrad('FailureDeleteFileData'));
          succes = false;
        }
        if (succes) {
          this.toast.showSuccessToast(this.coreService.getTrad('FileDeleted'));
        }
        this.loaded = false;
        this.getMedias();
        this.closeModal('mediaDeleteModal');
      });

    // this.mediaService.deleteMedia(previewsToDelete, 'PREVIEW').subscribe(
    //   (result) => {
    //     this.toast.showSuccessToast('previews deleted');
    //   },
    // (error: any) => {
    //   this.toast.showAlertToast('previews NOT deleted');
    // });
    // this.mediaService.deleteMedia(media.FullName, media.Type).subscribe(
    //   (result) => {
    //     this.toast.showSuccessToast('media deleted');
    //   },
    // (error: any) => {
    //   this.toast.showAlertToast('media NOT deleted');
    // }
    // );
    // this.mediaService.DeleteMediaBo(media).subscribe(
    //   (result) => {
    //     this.toast.showSuccessToast('BO deleted');
    //   },
    // (error: any) => {
    //   this.toast.showAlertToast('BO NOT deleted');
    // }
    // );
  }

  public OpenModal(mediaSelected: ParamsMedia, idModal: string, index: number): void {
    this.stopCarousel(mediaSelected, index);
    this.afficheMedia = mediaSelected;
    this.modalService.open(idModal);
    //switch(idModal) {
    //  case 'zoomMediaListModal':
    //    if (this.afficheMedia.Path && this.afficheMedia.Type === 'VIDEO') {
    //      this.playerPlyr = new Plyr('#plyrID', { captions: { active: true } });
    //    }
    //  break;
    //}
  }

  public closeModal(idModal: string): void {
    this.afficheMedia = new ParamsMedia;
    this.modalService.close(idModal);
  }

  public openAlertModal(): void {
    this.modalService.open('deleteDataBaseErrors');
  }

  public closeAlertModal(): void {
    this.modalService.close('deleteDataBaseErrors');
  }

  public affichePagination(index: number): boolean {
    // gestion de l'affichage quand :

    // le nombre de pages est inférieur à 10 + 3
    if (this.PageManager.ArrayPageTotal.length <= this.PageManager.numberStrartEndElements[0] + this.PageManager.numberCenterElements) {
      return true;

    // le numéro de la page sélectionnée est inférieur à 10 - 3
    } else if (this.PageManager.indexSelectedPage < this.PageManager.numberStrartEndElements[0] - this.PageManager.numberCenterElements) {
      if (index < this.PageManager.numberStrartEndElements[0]) {
        return true;
      } else if (index >= this.PageManager.ArrayPageTotal.length - this.PageManager.numberCenterElements) {
        return true;
      } else {
        return false;
      }

    // le numéro de la page sélectionnée est inférieur à 10
    } else if (this.PageManager.indexSelectedPage < this.PageManager.numberStrartEndElements[0]) {
      if (index < this.PageManager.numberStrartEndElements[0]) {
        return true;
      } else if (index <= this.PageManager.indexSelectedPage + this.PageManager.numberCenterElements) {
          return true;
        } else if (index >= this.PageManager.ArrayPageTotal.length - this.PageManager.numberCenterElements) {
          return true;
        } else {
          return false;
      }

    // le numéro de la page sélectionnée est suppérieur à la taille max - (10 - 3)
    } else if (this.PageManager.indexSelectedPage >= this.PageManager.ArrayPageTotal.length - (this.PageManager.numberStrartEndElements[0] - this.PageManager.numberCenterElements)) {
      if (index >= this.PageManager.ArrayPageTotal.length - this.PageManager.numberStrartEndElements[0]) {
        return true;
      } else if (index < this.PageManager.numberCenterElements) {
        return true;
      } else {
        return false;
      }

    // le numéro de la page sélectionnée est suppérieur à la taille max - 10
    } else if (this.PageManager.indexSelectedPage >= this.PageManager.ArrayPageTotal.length - this.PageManager.numberStrartEndElements[0]) {
      if (index >= this.PageManager.ArrayPageTotal.length - this.PageManager.numberStrartEndElements[0]) {
        return true;
      } else if (index >= this.PageManager.indexSelectedPage - this.PageManager.numberCenterElements) {
        return true;
      } else if (index < this.PageManager.numberCenterElements) {
        return true;
      } else {
        return false;
      }

    // le numéro de la page sélectionnée se trouve au milieu de la liste des pages
    } else if (index <= this.PageManager.indexSelectedPage + this.PageManager.numberCenterElements && index >= this.PageManager.indexSelectedPage - this.PageManager.numberCenterElements) {
      return true;
    } else if (index < this.PageManager.numberStrartEndElements[1]) {
      return true;
    } else if (index >= this.PageManager.ArrayPageTotal.length - this.PageManager.numberStrartEndElements[1]) {
      return true;
    } else {
      return false;
    }

  }

  public afficheDotes(index: number, type: string): boolean {
    let result: boolean = false;
    switch (type) {
      case 'start':
        if (index < this.PageManager.numberStrartEndElements[0] - this.PageManager.numberCenterElements) {
          result = false;
        } else if (index > this.PageManager.ArrayPageTotal.length - this.PageManager.numberStrartEndElements[0]) {
          result = false;
        } else if (this.PageManager.indexSelectedPage >= this.PageManager.ArrayPageTotal.length - (this.PageManager.numberStrartEndElements[0] - this.PageManager.numberCenterElements) && index === this.PageManager.ArrayPageTotal.length - this.PageManager.numberStrartEndElements[0]) {
          result = true;
        } else if (index === this.PageManager.indexSelectedPage - this.PageManager.numberCenterElements) {
          result = true;
        } else {
          result = false;
        }
        break;
      case 'end':
        if (index < this.PageManager.numberStrartEndElements[0] - 1) {
          result = false;
        } else if (index >= this.PageManager.ArrayPageTotal.length - (this.PageManager.numberStrartEndElements[0] - this.PageManager.numberCenterElements)) {
          result = false;
        } else if (this.PageManager.indexSelectedPage < this.PageManager.numberStrartEndElements[0] - this.PageManager.numberCenterElements && index === this.PageManager.numberStrartEndElements[0] - 1) {
          result = true;
        } else if (index === this.PageManager.indexSelectedPage + 3) {
          result = true;
        } else {
          result = false;
        }
        break;
    }
    return result;
  }

  public checkMedia(media: ParamsMedia, index: number): void {
    this.stopCarousel(media, index);
    clearInterval(this.intervalCarousel);
    this.selectMedia.emit(media);
  }

  public deleteErrorsMedias(): void {
    this.dialogService.showSplash(true);

    if (this.ListMediaToDeleteFromDatabase.length > 0) {
      const ListSub: Array<Observable<MediaQueovalModel>> = new Array<Observable<MediaQueovalModel>>();
      this.ListMediaToDeleteFromDatabase.forEach((media: ErrorParamsMedia) => {
        ListSub.push(this.mediaService.DeleteMediaBo(media));
      });

      forkJoin(ListSub).subscribe(
        (deleteResults: Array<MediaQueovalModel>) => {
          deleteResults.forEach((result: MediaQueovalModel) => {

            if (result.Alert && result.Alert.length > 0) {
              result.Alert.split('<br />').forEach((alert: string) => {
                this.toast.showWarningToast(alert);
              });
            }

            let succes: boolean = true;
            if (result.HasError) {
              this.toast.showAlertToast(this.coreService.getTrad('FailureDeleteFile'));
              succes = false;
            }

            if (succes) {
              this.toast.showSuccessToast(this.coreService.getTrad('FileDeleted'));
            }
            this.getMedias();
            this.closeAlertModal();
            this.dialogService.showSplash(false);
          });
        }
      );
    }
  }

  public getTradType(type: string): string {
    switch (type) {
      case MediaTypeCode.VIDEO:
        return 'video';
      case MediaTypeCode.AUDIO:
        return 'audio';
      case MediaTypeCode.DOCUMENT:
        return 'document';
      case MediaTypeCode.IMAGE:
        return 'image';
      default:
        return '';
    }
  }

  // #endregion METHODES PUBLIQUES

  // #region METHODES PRIVEES
  private getMedias(): void {
    this.loaded = false;
    this.dialogService.showSplash(true);
    // récupère les médias stockés en BDD par rapport à la restriction imposée par le developpeur
    this.mediaService.GetMediasFromBo(this.restrictedTo).subscribe(
      (result: MediaQueovalModel) => {
        //if (result.Alert && result.Alert.length > 0) {
         // this.ListMediaToDeleteFromDatabase = result.MediaModel.ListMediasErrors;
        //  result.Alert.split('<br />').forEach((alert: string) => {
        //    this.toast.showWarningToast(alert);
        //  });
        //}
        if (result.HasError) {
          this.dialogService.showSplash(false);
          this.toast.showAlertToast(`${this.coreService.getTrad('ErrorRecoveringFiles')} : ${result.Error}`);
        } else {
          this.ListMediaToDeleteFromDatabase = result.MediaModel.ListMediasErrors;
          this.PageManager.ArrayPageTotal = Array(Math.ceil(result.MediaModel.ListMedia.length / this.filter.numberByPage));
          this.AllMedias = result.MediaModel.ListMedia;
          this.ApplyFilters(result.MediaModel.ListMedia);

          const _sortedKeys: Array<string> = Object.keys(this.filter.sorted);
          const _sortedValues: Array<boolean> = Object.values(this.filter.sorted);
          for (let j: number = 0; j < this.sorted.length; j++) {
            if (_sortedValues[j]) {
              this.onSort(_sortedKeys[j]);
              break;
            }
          }
          this.dialogService.showSplash(false);
        }
        this.loaded = true;
      });
  }

  public addImgCanNotAffiche(url: string): void {
    this.imgCanNotAffiche.push(url);
  }

  private InitProperties(): void {
    this.restrictedTo = this.restrictedTo ? this.restrictedTo : new FilterMedia;
    // test
    // this.restrictedTo.byType.audio = false;
    this.filter = this.filter ? this.filter : new FilterMedia;
    // this.filter.numberByPage = 1;
    this.PageManager.indexLastMediaExclued = this.filter.numberByPage;
    this.AllMedias = new Array<ParamsMedia>();
    this.numberByPage = [1, 5, 10, 15, 25, 35, 50];
    this.ListTypes = [{ key: '', selected: true }];
    this.sorted = [];
    this.datePicker = { Mode: 'SIMPLE', MainElementList: [{ ID: 'date', Required: '', Value: '' }] };
  }

  private fillInProperties(): void {
    this.selects = [false, false];
    this.afficheMedia = new ParamsMedia;
    const _sortedKeys: Array<string> = Object.keys(this.filter.sorted);
    const _sortedValues: Array<boolean> = Object.values(this.filter.sorted);
    for (let i: number = 0; i < _sortedKeys.length; i++) {
      if (_sortedKeys[i] !== 'ascending') {
        this.sorted.push({ key: _sortedKeys[i], value: _sortedValues[i] });
      }
    }

    // définit les types sélectionnables en fonction de la restriction imposée par le developpeur
    const _keysFiltersByTypes: Array<string> = Object.keys(this.restrictedTo.byType);
    const _valuesFiltersByTypes: Array<boolean> = Object.values(this.restrictedTo.byType);
    let nbSelectedTypes: number = 0;
    let _typeSelected: string = '';
    for (let i: number = 0; i < _valuesFiltersByTypes.length; i++) {
      if (_valuesFiltersByTypes[i]) {
        nbSelectedTypes++;
      }
    }
    if (nbSelectedTypes > 1) {
      this.ListTypes.push({ key: 'AllTypes', selected: false });
    }
    for (let i: number = 0; i < _keysFiltersByTypes.length; i++) {
      if (_valuesFiltersByTypes[i]) {
        this.ListTypes.push({ key: _keysFiltersByTypes[i], selected: _valuesFiltersByTypes[i] });
        _typeSelected = _valuesFiltersByTypes[i] ? _keysFiltersByTypes[i] : _typeSelected;
      }
    }
    if (nbSelectedTypes > 1) {
      this.addType('AllTypes');
    } else {
      this.addType(_typeSelected);
    }
  }

  public getPage(value: number): void {
    this.filter.numberByPage = value;
    this.closeAlloptionsList();
  }
  private closeAlloptionsList(): void {
    for (let i: number = 0; i < this.selects.length; i++) {
      this.selects[i] = false;
    }
  }

  private SortAscending(valA: string | Date, valB: string | Date): number {
    if (typeof valA == 'string' && typeof valB == 'string') {
      if (valA.toLowerCase() < valB.toLowerCase()) {
        return -1;
      } else if (valA.toLowerCase() > valB.toLowerCase()) {
        return 1;
      } else { return 0; }
    }
    else if (typeof valA != 'string' && typeof valB != 'string')
    {
      if (valA.getTime() < valB.getTime()) {
        return -1;
      }
      else if (valA.getTime() > valB.getTime()) {
        return 1;
      }
      else {return 0}
    }
    return 0
  }

  private SortDescending(valA: string | Date, valB: string | Date): number {
    if (typeof valA == 'string' && typeof valB == 'string') {
    if (valA.toLowerCase() > valB.toLowerCase()) {
      return -1;
    } else if (valA.toLowerCase() < valB.toLowerCase()) {
      return 1;
      } else { return 0; }

    }
    else if (typeof valA != 'string' && typeof valB != 'string') {
      if (valA.getTime() < valB.getTime()) {
        return -1;
      }
      else if (valA.getTime() > valB.getTime()) {
        return 1;
      }
      else { return 0 }
    }
    return 0
  }

  private sorting(): void {
    if (this.filter.sorted.ascending) {
      this.AllMedias.sort((a: ParamsMedia, b: ParamsMedia) => {
        switch (this.TypeSortedSelected) {
          case 'Type':
            return this.SortAscending(a.Type, b.Type);
          case 'Name':
            return this.SortAscending(a.Name, b.Name);
          case 'DateCreation':
            return this.SortAscending(a.DateCreation, b.DateCreation);
          default:
            return this.SortAscending(a.DateCreation, b.DateCreation);
        }

        //if (this.TypeSortedSelected === "Type" || this.TypeSortedSelected === "Name" || this.TypeSortedSelected === "DateCreation") {
        //  if (a[this.TypeSortedSelected].toLowerCase() < b[this.TypeSortedSelected].toLowerCase()) {
        //    return -1;
        //  } else if (a[this.TypeSortedSelected].toLowerCase() > b[this.TypeSortedSelected].toLowerCase()) {
        //    return 1;
        //  } else { return 0; }
        //}
      });
    } else {
      this.AllMedias.sort((a: ParamsMedia, b: ParamsMedia) => {
        switch (this.TypeSortedSelected) {
          case 'Type':
            return this.SortDescending(a.Type, b.Type);
          case 'Name':
            return this.SortDescending(a.Name, b.Name);
          case 'DateCreation':
            return this.SortDescending(a.DateCreation, b.DateCreation);
          default:
            return this.SortDescending(a.DateCreation, b.DateCreation);
        }
        //if (a[this.TypeSortedSelected].toLowerCase() > b[this.TypeSortedSelected].toLowerCase()) {
        //  return -1;
        //} else if (a[this.TypeSortedSelected].toLowerCase() < b[this.TypeSortedSelected].toLowerCase()) {
        //  return 1;
        //} else { return 0; }
      });
    }
    this.ApplyFilters(this.AllMedias);
  }

  // #endregion METHODES PRIVEES
}

